import React, { useEffect, useMemo, useState } from 'react';
import { parseWheelInspection } from '../../utils/wheelInspectionUtil';
import WheelReportPhotoPositionGroup from './WheelReportPhotoPositionGroup';
import {
  buildPrePhotoSlots,
  padPrePhotoSlotsForGrid,
} from './wheelReportPhotoUtil';

const PRE_SECTION_TITLE = '4. 휠 복원전 사진';

const WheelRestorationPrePhotoSection = ({ photos = [], vehicleInformation = {} }) => {
  const inspection = parseWheelInspection(vehicleInformation);
  const [resolvedPhotos, setResolvedPhotos] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!photos?.length) {
        setResolvedPhotos([]);
        return;
      }
      const base = process.env.REACT_APP_S3_BASE_URL || '';
      const resolved = await Promise.all(
        photos.map(async (img) => ({
          ...img,
          src: img.src || (img.filePath ? `${base}${img.filePath}` : ''),
        }))
      );
      if (!cancelled) setResolvedPhotos(resolved);
    })();
    return () => {
      cancelled = true;
    };
  }, [photos]);

  const slots = useMemo(() => {
    const findSrc = (partCode) =>
      resolvedPhotos.find((p) => p.partCode === partCode && p.src)?.src || null;
    return padPrePhotoSlotsForGrid(buildPrePhotoSlots(inspection, findSrc));
  }, [resolvedPhotos, inspection]);

  const hasPhotos = useMemo(() => {
    const findSrc = (partCode) =>
      resolvedPhotos.find((p) => p.partCode === partCode && p.src)?.src || null;
    return buildPrePhotoSlots(inspection, findSrc).length > 0;
  }, [resolvedPhotos, inspection]);

  if (!hasPhotos) return null;

  return (
    <div className="wheel-report-pre-photos">
      <h2 className="wheel-report-section-title">{PRE_SECTION_TITLE}</h2>
      <WheelReportPhotoPositionGroup
        slots={slots}
        columns={3}
        gridLayout="3x2"
        showHeader={false}
      />
    </div>
  );
};

export default WheelRestorationPrePhotoSection;
